import React from "react"

import { useApp } from "../../hooks/useApp"
import { useTemplate } from "../../hooks/useTemplate"
import { useRoutes } from "../../hooks/useRoutes"
import { usePage } from "../../hooks/usePage"
import { useSanity } from "../../hooks/useSanity"

export const withLocked = Component => ({ name = "Locked" }) => {
  const { setRegister } = useApp()
  const { provider } = useTemplate()
  const { linkResolver } = useRoutes()
  const { search } = usePage()
  const { sanityContent } = useSanity()

  const locales = React.useMemo(
    () => ({
      ...provider,
      ...search,
      ctaLink: linkResolver(search?.ctaLink),
      ctaUpsellTitle: sanityContent(search?.ctaUpsellTitle),
    }),
    [linkResolver, provider, sanityContent, search]
  )

  const handleRegister = () => setRegister((prevState: boolean) => !prevState)

  Component.displayName = name
  return <Component handleRegister={handleRegister} locales={locales} />
}
